import React from 'react';
import JobWizardPage from '../JobWizard';
import JobWizardPageRerun from '../JobWizard/JobWizardPageRerun';

const ForemanREXRoutes = [
  {
    path: '/experimental/job_wizard/new',
    exact: true,
    render: () => <JobWizardPage />,
  },
  {
    path: '/experimental/job_wizard/:id/rerun',
    exact: true,
    render: props => <JobWizardPageRerun {...props} />,
  },
];

export default ForemanREXRoutes;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_remote_execution-8.0.0-2.fm3_4.el8.noarch/usr/share/gems/gems/foreman_remote_execution-8.0.0/webpack/Routes/routes.js